import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureVisit } from "../helpers/analytics";

export default function PublishingAnalytics() {
  const location = useLocation();
  useEffect(() => { captureVisit(); }, [location.key]);
  return null;
}
